import {Injectable} from '@angular/core';
import {SuperRepoRepository} from './super-repo.repository';
import {HttpClient, HttpParams} from '@angular/common/http';
import {GetPayloadInterface} from '../../models/get-payload.interface';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BaseRepository extends SuperRepoRepository {
    protected path: string = null;

    constructor(httpClient: HttpClient) {
        super();
        this.httpClient = httpClient;
    }

    getAll(): Observable<any> {
        return super.get(this.path);
    }

    getAllByFilter(filter: GetPayloadInterface): Observable<any> {
        const path = this.path + '/new';
        const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
        return super.get(path, options);
    }

    save(payload: PostPayloadInterface): Observable<any> {
        return super.post(this.path, payload);
    }

    update(payload: PostPayloadInterface): Observable<any> {
        const path = this.path + '/' + payload.id.toString();
        return super.put(path, payload);
    }
    updateWithoutId(payload: PostPayloadInterface): Observable<any> {
        const path = this.path;
        return super.put(path, payload);
    }

    deleteById(id): Observable<any> {
        const path = this.path + '/' + id;
        return super.delete(path);
    }


}
